import React from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import BrandSection from "@/components/BrandSection";
import FeaturedWork from "@/components/FeaturedWork";
import ContentHub from "@/components/ContentHub";
import ServicesSection from "@/components/ServicesSection";
import Footer from "@/components/Footer";
import ScrollJourney from "@/components/ScrollJourney";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#F5F0E8]">
      <Header />
      <HeroSection />
      <ScrollJourney />
      <AboutSection />
      <BrandSection />
      <FeaturedWork />
      <ContentHub />
      <ServicesSection />
      <Footer />
    </div>
  );
};

export default HomePage;
